import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import axios from 'axios';
import {apiRoutes} from '../apiRoutes'
import {authHeader} from '../global'

Vue.use(VueRouter);

// configure router
const router = createRouter()

/**
 * Create a new router instance.
 */
 function createRouter() {
  const router = new VueRouter({
      mode: 'history',
      linkActiveClass: 'active',
      routes: routes,
      scrollBehavior: (to, from ,savedPosition) => {
        if (savedPosition) {
          return savedPosition;
        }
        if (to.hash) {
          return { selector: to.hash };
        }
        return { x: 0, y: 0 };
      }
  })

  // Check user authentication before route to requested page
  router.beforeEach(beforeEach)

  //router.afterEach(afterEach)

  return router
}

async function beforeEach(to, from, next) {
  // Get the matched components and resolve them
  if (to.meta.requireAuth) {
    let access_token = localStorage.getItem("access_token")
    if(access_token) {
      let isValid = await isValidAccess(to.name, to.path);
      if(isValid)
      {
        next();
      }
      else {
        if(to.path != '/login')
          next("/login");
      }

      next()
    }
    else {
      next("/login");
    }
  }
  else {
    next();
  }

}

async function isValidAccess(name, path, id){
  let isValid = 0
    // alert(path)
    // path = path.substr(0, path.lastIndexOf("/"))
    // console.log(path)
    if (id != null)
    {
      path = path.substr(0, path.lastIndexOf("/"))
    }
  await axios.post(`${apiRoutes['IS_VALID_ACCESS_TOKEN']}`, {name:name, path:path}, authHeader())
            .then(response => {
              // console.log(response.data)
                if(response.data.code == 1){
                   isValid = 1
                }
                else
                {
                  Vue.notify({group: 'notify', type: 'error', text: "User has no access!", max: 5, duration: 5000, speed: 300})                  
                }
            })
            .catch(error => {
                if (error.response) {
                    Vue.notify({ group: 'notify', type: 'error', text: "User has no access!", max: 5, duration: 5000, speed: 300})
                } else {
                    console.log("Problem with access", error);
                }
            });

  return isValid
}

export default router;
